"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var __1 = require("..");
var core_1 = require("@material-ui/core");
exports.default = react_1.forwardRef(function SimpleTabs(_a, ref) {
    var _b;
    var _c = _a.value, outerValue = _c === void 0 ? 0 : _c, paperProps = _a.paperProps, padding = _a.padding, data = _a.data, _d = _a.color, color = _d === void 0 ? 'primary' : _d, _e = _a.centered, centered = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? 'standard' : _f, onChange = _a.onChange;
    var _g = react_1.useState(0), value = _g[0], setValue = _g[1];
    react_1.useEffect(function () { return setValue(outerValue); }, [outerValue]);
    var classes = useStyles({ padding: padding });
    var handleChange = function (event, newValue) {
        if (onChange) {
            onChange(event, newValue);
        }
        else {
            setValue(newValue);
        }
    };
    var content = (_b = data[value]) === null || _b === void 0 ? void 0 : _b.content;
    var Component = typeof content === 'string' ? __1.P : 'div';
    return (jsx_runtime_1.jsxs(__1.Paper, __assign({}, paperProps, { ref: ref }, { children: [jsx_runtime_1.jsx(__1.Tabs, __assign({ className: classes.tabs, indicatorColor: color, value: value, onChange: handleChange, centered: centered, variant: variant }, { children: data.map(function (props, index) { return (jsx_runtime_1.jsx(__1.Tab, __assign({}, props), props.label + "+" + index + "+" + props.value)); }) }), void 0),
            content && jsx_runtime_1.jsx(Component, __assign({ className: classes.container }, { children: content }), void 0)] }), void 0));
});
var useStyles = core_1.makeStyles(function (theme) { return ({
    container: {
        padding: function (_a) {
            var padding = _a.padding;
            return padding || theme.spacing(2);
        },
    },
    tabs: {
        background: theme.palette.action.hover,
        boxShadow: 'inset 0 -6px 7px -10px #000',
        borderTopLeftRadius: theme.shape.borderRadius * 0.9,
        borderTopRightRadius: theme.shape.borderRadius * 0.9,
    },
}); });
//# sourceMappingURL=SimpleTabs.js.map